import React from "react";

import {
  Box,
  Grid,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  makeStyles,
  Typography,
} from "@material-ui/core";

import { Check } from "@material-ui/icons";
import StepNumber from "./StepNumber";
import classNames from "classnames";

const useStyles = makeStyles((theme) => ({
  container: {
    display: "grid",
    gridTemplateColumns: "min-content 1fr",
    gap: theme.spacing(2),
  },
  listItem: {
    padding: 0,
  },
  listItemIcon: {
    minWidth: theme.spacing(4),
  },
  linkWithUnderline: {
    textDecoration: "underline",
    "&:hover": {
      textDecoration: "none",
    },
  },
  stepTitle: {
    color: "#0EBB97",
  },
  textWithSpace: {
    marginBottom: theme.spacing(0.5),
    marginTop: theme.spacing(2),
  },
  textBold: {
    fontWeight: "bold",
  },
}));

const SubStep1 = () => {
  const classes = useStyles();

  return (
    <Box className={classes.container}>
      <StepNumber step="1" />
      <Box>
        <Grid container spacing={5}>
          <Grid item>
            <Grid container spacing={1} direction="column">
              <Grid
                item
                component={Typography}
                variant="h6"
                className={classes.stepTitle}
              >
                Настроить iiko для работы с&nbsp;GuestMe
              </Grid>
              <Grid item component={Typography} variant="body1">
                На&nbsp;этом шаге будут выполнены следующие действия:
              </Grid>
              <Grid item>
                <List disablePadding>
                  <ListItem className={classes.listItem}>
                    <ListItemIcon className={classes.listItemIcon}>
                      <Check />
                    </ListItemIcon>
                    <ListItemText primary="Установка плагина GuestMe на&nbsp;главный терминал iikoFront в&nbsp;вашем ресторане" />
                  </ListItem>

                  <ListItem className={classes.listItem}>
                    <ListItemIcon className={classes.listItemIcon}>
                      <Check />
                    </ListItemIcon>
                    <ListItemText primary="Активация лицензии GuestMe для&nbsp;iiko (включено в&nbsp;абонентскую плату сервиса)" />
                  </ListItem>

                  <ListItem className={classes.listItem}>
                    <ListItemIcon className={classes.listItemIcon}>
                      <Check />
                    </ListItemIcon>
                    <ListItemText primary="Базовые настройки iiko для&nbsp;работы плагина" />
                  </ListItem>
                </List>
              </Grid>
            </Grid>
          </Grid>
          <Grid item>
            <Typography variant="body1">
              Эти действия можно выполнить двумя способами:
            </Typography>

            <Typography
              variant="body1"
              className={classNames(classes.textWithSpace, classes.textBold)}
            >
              Через дилера iiko
            </Typography>

            <Typography variant="body1" component="span">
              Свяжитесь с дилером iiko, обслуживающим вашу организацию. Он
              проведет необходимые операции. Срок подключения зависит
              от&nbsp;конкретного дилера iiko.
            </Typography>

            <Typography
              variant="body1"
              className={classNames(classes.textWithSpace, classes.textBold)}
            >
              С&nbsp;помощью специалистов GuestMe
            </Typography>

            <Typography variant="body1" component="span">
              Наши специалисты оперативно активируют нужную лицензию iiko
              и&nbsp;помогут всё настроить. Все работы проводятся бесплатно.
              GuestMe&nbsp;&mdash; официальный партнер iiko, поэтому мы
              гарантируем качество и&nbsp;безопасность выполнения этих работ.
              Процесс занимает{" "}
              <b>от&nbsp;нескольких минут до&nbsp;одного дня</b>,{" "}
              в&nbsp;зависимости от&nbsp;сложности вашей конфигурации iiko.
            </Typography>

            <Typography variant="body1" className={classes.textWithSpace}>
              Контакты технической поддержки GuestMe:
            </Typography>

            <Typography variant="body1" className={classes.textBold}>
              <a href="tel:+74954765242">+7 495 476 5242</a>
            </Typography>

            <Typography variant="body1" className={classes.textBold}>
              <a
                className={classes.linkWithUnderline}
                href={"mailto:support@guestme.ru"}
              >
                support@guestme.ru
              </a>
            </Typography>
          </Grid>
        </Grid>
      </Box>
    </Box>
  );
};

export default SubStep1;
